import {
    ListingResponseDtoType,
    ListingDetailOutdoorSpaceResponseDtoKind,
    ListingResponseDtoPriceType,
} from '@/api/generated/model';

export const ListingType = ListingResponseDtoType;
export const ListingCurrencyCode = { EUR: 'EUR' };

export type ListingCurrencyCode = (typeof ListingCurrencyCode)[keyof typeof ListingCurrencyCode];

export const OutdoorSpaceKind = ListingDetailOutdoorSpaceResponseDtoKind;
export type OutdoorSpaceKind = (typeof OutdoorSpaceKind)[keyof typeof OutdoorSpaceKind];

export const ListingPriceType = ListingResponseDtoPriceType;
